module.exports = __webpack_public_path__ + "img/img_8.0200f75f.jpg";